<template>
  <div class="container">
    <div class="find_wrap">
      <div class="tab_area">
        <div id="" class="on">STEP 01. 비밀번호 찾기</div>
        <div id="" class="">STEP 02. 비밀번호 변경</div>
      </div>
      <div class="find_form find_form_pw">
        <div class="find_title">
          라온 메타데미에 가입 정보를 입력하시면, 이메일 확인 후 비밀번호 변경이
          진행됩니다.
        </div>
        <div class="find_type">
          <!-- <div class="pw_types on" attr-find="info">가입 정보로 비밀번호 변경</div> -->
          <!-- <div class="pw_types find_pw_qr" attr-find="qr">모바일 학생증으로 비밀번호 변경</div> -->
        </div>
        <div class="form_area">
          <!-- <form action="/find_pw" id="find" method="POST" onsubmit="return formCheckFindPw(this)"> -->
          <form id="find" method="POST" @submit.prevent="sendData()">
            <div class="find_form_inner find_form_info">
              <table class="table_style_find_pw">
                <tbody>
                  <tr>
                    <th><span>*</span>아이디</th>
                    <td>
                      <input
                        id="user_id"
                        v-model="userID"
                        type="text"
                        name=""
                        placeholder="아이디를 입력해주세요."
                      />
                    </td>
                  </tr>
                  <tr>
                    <th><span>*</span>이름</th>
                    <td>
                      <input
                        id="user_name"
                        v-model="userName"
                        type="text"
                        name=""
                        placeholder="이름을 입력해주세요."
                      />
                    </td>
                  </tr>
                  <tr>
                    <th><span>*</span>이메일</th>
                    <td>
                      <input
                        id="user_email"
                        v-model="userEmail"
                        type="email"
                        name=""
                        placeholder="메일주소를 입력해주세요."
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="btn_area">
                <a href="/login" class="btn_orange btn_cancel">취소</a>
                <input
                  v-if="cntSendNum === 0"
                  type="submit"
                  class="btn_orange"
                  value="확인"
                />
                <input v-else type="submit" class="btn_orange" value="재전송" />
              </div>
            </div>
          </form>
        </div>
        <div class="Modals">
          <ModalAlert
            :alert-msg="errMsg"
            :is-open="errStatus"
            :countdown="cntSendNum > 0 ? countdown : 0"
            @update:is-open="updateStatus"
          ></ModalAlert>
          <!-- <ModalAlert
            :alertMsg="errMsg"
            :isOpen="errStatus"
            :timerSetting="timerStart ? countdown : 0"
            @update:isOpen="updateStatus"
          ></ModalAlert> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { sendEmailForPW } from '../api/find'
import ModalAlert from '../components/ModalAlert.vue'

export default {
  name: 'FindPWViews',
  components: {
    ModalAlert,
  },
  setup() {
    const errMsg = ref('')
    const errStatus = ref(false)

    const userName = ref('')
    const userID = ref('')
    const userEmail = ref('')

    const cntSendNum = ref(0)
    const timerStart = ref(false)
    const countdown = ref(0)

    const startTimer = () => {
      timerStart.value = true
      countdown.value = 60
      const timer = setInterval(() => {
        if (countdown.value > 0) {
          countdown.value -= 1
        } else {
          clearInterval(timer)
          timerStart.value = false
        }
      }, 1000)
    }

    const sendData = async () => {
      if (timerStart.value) {
        errStatus.value = true
        errMsg.value = ''
        // errMsg.value = `${countdown.value}초 후에 다시 시도해주세요.`
        // errMsg.value = ''
        return
      }
      if (!userID.value) {
        errStatus.value = true
        errMsg.value = '가입 시 등록한 아이디를 입력해 주세요.'
        return
      }
      if (!userName.value) {
        errStatus.value = true
        errMsg.value = '가입 시 등록한 이름을 입력해 주세요.'
        return
      }
      if (!userEmail.value) {
        errStatus.value = true
        errMsg.value = '가입 시 등록한 이메일 주소를 입력해 주세요.'
        return
      }
      try {
        const checksendingEmail = await sendEmailForPW(
          userID.value,
          userName.value,
          userEmail.value
        )
        if (checksendingEmail.code === 'MB22000200') {
          errStatus.value = true
          errMsg.value =
            '이메일 전송 완료 <br> 이메일 주소로 받은 링크를 클릭하여 <br> 비밀번호를 재설정해주세요.'
          cntSendNum.value += 1

          startTimer()
        } else if (checksendingEmail.code === 'MB22001400') {
          // 유효하지 않은 이메일 형식
          errStatus.value = true
          errMsg.value = '이메일 형식을 확인해주세요.'
        } else if (checksendingEmail.code === 'MB22002404') {
          // 회원 정보를 찾을 수 없음
          errStatus.value = true
          errMsg.value =
            '회원 정보를 찾을 수 없습니다. <br> 입력하신 가입 정보를 다시 확인해주세요.'
        } else if (
          checksendingEmail.code === 'MB22003500' ||
          checksendingEmail.code === 'MB22004500'
        ) {
          errStatus.value = true
          errMsg.value =
            '시스템 에러가 발생했습니다. <br> 같은 에러가 계속 발생한다면 서비스 이용 문의로 문의해 주세요.'
        }
      } catch (err) {
        console.log(err)
      }
    }
    const updateStatus = () => {
      errStatus.value = false
    }
    onMounted(() => {})
    return {
      errMsg,
      errStatus,

      userName,
      userID,
      userEmail,

      sendData,
      updateStatus,
      cntSendNum,
      countdown,
      timerStart,
    }
  },
}
</script>
